import React, {useEffect, useState} from 'react'
import {
    getGoogleDomains,
    getOfficeDomains,
    updateGoogleDomains,
    updateOfficeDomains
} from '../../services/domainService'
import PageTitle from '../components/Common/PageTitle'
import DomainForLoop from "../../modules/domains/DomainForLoop";
import Notify from "../../utility/notifications/Notify";
import Message from "../../utility/notifications/Message";

export default function Domains() {
    const [officeDomains, setOfficeDomains] = useState([])
    const [googleDomains, setGoogleDomains] = useState([])

    const [isOfficeSaving, setIsOfficeSaving] = useState(false)
    const [isGoogleSaving, setIsGoogleSaving] = useState(false)

    useEffect(() => {
        async function fetchOfficeDomains() {
            const response = await getOfficeDomains()
            setOfficeDomains(response.data.result)
        }
        async function fetchGoogleDomains() {
            const response = await getGoogleDomains()
            setGoogleDomains(response.data.result)
        }
        fetchOfficeDomains()
        fetchGoogleDomains()
    }, [])

    async function handleGoogleSubmit(data) {
        var newData = data?.domains.length > 0 ? {domains: data?.domains?.map((domain) => domain.email)} : {domains: []}

        setIsGoogleSaving(true)

        await updateGoogleDomains(newData).then(res => {
            if (res.status === 200) {
                setIsGoogleSaving(false);
                Notify.success('Google domains are successfully updated');
            }
        }).catch((err) => {
            if (err.response) {
                console.log(err)
                setIsGoogleSaving(false);
                Message(
                    err.response.data.error.message,
                    err.response.data.error.details,
                    "error"
                );
            }
        });
    }

    async function handleOfficeSubmit(data) {
        var newData = {domains: data?.domains?.map((domain) => domain.email)}


        setIsOfficeSaving(true)

        await updateOfficeDomains(newData)
            .then(res => {
            if (res.status === 200) {
                setIsOfficeSaving(false);
                Notify.success('Office domains are successfully updated');
            }
        })
        .catch((err) => {
            if (err.response) {
                setIsOfficeSaving(false);
                Message(
                    err.response.data.error.message,
                    err.response.data.error.details,
                    "error"
                );
            }
        });
    }

    return <>
        <PageTitle title={'Domain overview'} />

        <PageTitle title={'Google domains'} hideBackButton/>
        <DomainForLoop isSubmitting={isGoogleSaving} domains={googleDomains} handleSubmit={handleGoogleSubmit} />

        <PageTitle title={'Microsoft Office domains'} hideBackButton/>
        <DomainForLoop isSubmitting={isOfficeSaving} domains={officeDomains} handleSubmit={handleOfficeSubmit} />
    </>
}